const ToastAlertActionTypes = {
  SET_ALERT: 'SET_ALERT',
  REMOVE_ALERT: 'REMOVE_ALERT',
};

export default ToastAlertActionTypes;
